import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';
import MapOverlay from '../enums/MapOverlay';
import TimeDrawerAction from '../enums/TimeDrawerAction';

type logMapOverlayTimeDrawerActionTappedParams = {
  map_location?: MapLocation;
  map_overlay?: MapOverlay;
  time_drawer_action?: TimeDrawerAction;
  to_overlay?: MapOverlay;
  trail_id?: string;
};

/**
 * A user interacts with the time picker/scrubber drawer on a map overlay. Event should fire once per action type taken per overlay per session. (E.g. if the user changes the date twice and interacts with the time scrubber three times in the precipitation filter, the event should fire once for changing the date and once for scrubbing the time) .
 * @param params - Attributes to log with the amplitude event
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.map_overlay - A string representing the map overlay selected
 * @param params.time_drawer_action - The action the user takes in the map overlay drawer
 * @param params.to_overlay - When the user takes a swapping overlay action
 * @param params.trail_id - Trail ID of the recap if applicable
 */
const logMapOverlayTimeDrawerActionTapped = (
  { map_location, map_overlay, time_drawer_action, to_overlay, trail_id }: logMapOverlayTimeDrawerActionTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'map overlay time drawer action tapped',
    {
      'map location': map_location,
      'map overlay': map_overlay,
      'time drawer action': time_drawer_action,
      'to overlay': to_overlay,
      'trail id': trail_id
    },
    callback
  );
};

export default logMapOverlayTimeDrawerActionTapped;
